import { useSelector } from "react-redux";
import { useRef, useState, useEffect } from "react";
import splits from "../../../assets/smartbuilding/controlEquipementSection/splits.png";
import mutlizone from "../../../assets/smartbuilding/controlEquipementSection/multizoneSplit.png";
import radiator from "../../../assets/smartbuilding/controlEquipementSection/radiators.png";
import lights from "../../../assets/smartbuilding/controlEquipementSection/lights.png";
import shades from "../../../assets/smartbuilding/controlEquipementSection/shades.png";
import IRVE from "../../../assets/smartbuilding/controlEquipementSection/IRVE.png";
import plateformeControlCVCDesktop from "../../../assets/smartbuilding/controlEquipementSection/mapAndThermostatDesktop.png";
import plateformeControlCVCMobile from "../../../assets/smartbuilding/controlEquipementSection/mapAndThermostatMobile.png";
import plateformeblocagecvcImage from "../../../assets/smartbuilding/controlEquipementSection/plateforme-blocage-cvc.png";
import plateformeblocagecvcMobileImage from "../../../assets/smartbuilding/controlEquipementSection/plateforme-blocage-cvc-mobile.png";
import plateformeHisoryImage from "../../../assets/smartbuilding/controlEquipementSection/plateforme-history.png";
import plateformeHisoryENImage from "../../../assets/smartbuilding/controlEquipementSection/plateforme-history-en.png";
import plateformCTAcontrolImage from "../../../assets/smartbuilding/controlEquipementSection/CTA.png";

const features = [
  {
    name: "splits",
    image: splits,
  },
  {
    name: "mutlizone",
    image: mutlizone,
  },
  {
    name: "radiator",
    image: radiator,
  },
  {
    name: "shades",
    image: shades,
  },

  {
    name: "lights",
    image: lights,
  },

  {
    name: "IRVE",
    image: IRVE,
  },
];

export default function ControleEquipementSection(props) {
  const { textContent, language } = { ...props };
  const screenWidth = useSelector((state) => state.screen.screenWidth);
  const isMobile = useSelector((state) => state.screen.isMobile);

  return (
    <section className="container">
      <div className="container-small">
        <h1 className="title-gradient">
          {textContent.ControleEquipementSection.title[language]}
        </h1>
        <h2> {textContent.ControleEquipementSection.subtitle[language]}</h2>
      </div>
      <div className="container-empty-small" />
      <div
        className={`grid-3 controlEquipement-sb ${isMobile ? "carousel" : ""}`}
      >
        {features.map((feature, index) => (
          <div className="controlEquipement-card-sb" key={index}>
            <div className="controlEquipementImage">
              <img src={feature.image} alt="" />
            </div>

            <div className="controlEquipementText">
              <h3 className="h3-bold">
                {
                  textContent.ControleEquipementSection.features?.items[
                    feature.name
                  ]?.title[language]
                }
              </h3>

              <p>
                {
                  textContent.ControleEquipementSection.features?.items[
                    feature.name
                  ]?.description[language]
                }
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="screen4">
        <div className="screen4-text">
          <h2 className="h2-bold">
            {
              textContent?.ControleEquipementSection?.screens?.mapAndThermostat
                ?.title[language]
            }
          </h2>
          <h3>
            {
              textContent?.ControleEquipementSection?.screens?.mapAndThermostat
                ?.subtitle[language]
            }
          </h3>
        </div>
        <div className="screen4Image">
          <img
            src={
              isMobile
                ? plateformeControlCVCMobile
                : plateformeControlCVCDesktop
            }
            aria-hidden="true"
          />
        </div>
        <div className="empty-container-extra-small" />
        <div className="screen4-text">
          <h2 className="h2-bold">
            {
              textContent?.ControleEquipementSection?.screens?.blockCVC?.title[
                language
              ]
            }
          </h2>
          <h3>
            {
              textContent?.ControleEquipementSection?.screens?.blockCVC
                ?.subtitle[language]
            }
          </h3>
        </div>
        <div className="screen4Image">
          <img
            src={
              isMobile
                ? plateformeblocagecvcMobileImage
                : plateformeblocagecvcImage
            }
            aria-hidden="true"
          />
        </div>
        <div className="empty-container-extra-small" />
        <div className="screen4-text">
          <h2 className="h2-bold">
            {
              textContent?.ControleEquipementSection?.screens?.CTA?.title[
                language
              ]
            }
          </h2>
          <h3>
            {
              textContent?.ControleEquipementSection?.screens?.CTA?.subtitle[
                language
              ]
            }
          </h3>
        </div>
        <div className="screen4Image">
          <img
            src={isMobile ? plateformCTAcontrolImage : plateformCTAcontrolImage}
            aria-hidden="true"
          />
        </div>
        <div className="empty-container-extra-small" />
        <div className="screen4-text">
          <h2 className="h2-bold">
            {
              textContent?.ControleEquipementSection?.screens?.history?.title[
                language
              ]
            }
          </h2>
          <h3>
            {
              textContent?.ControleEquipementSection?.screens?.history
                ?.subtitle[language]
            }
          </h3>
        </div>
        <div className="screen4Image">
          <img
            src={
              language === "fr"
                ? plateformeHisoryImage
                : plateformeHisoryENImage
            }
            aria-hidden="true"
          />
        </div>
      </div>
    </section>
  );
}
